import { withInstall } from '@hd-front-end/utils'
import Transfer from './src/transfer.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElTransfer: SFCWithInstall<typeof Transfer> = withInstall(Transfer)
export default ElTransfer

export * from './src/transfer'
